import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, map, exhaustMap, tap, finalize } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    addRecord,
    addRecordSuccess,
    addRecordFailure,
    updateRecord,
    updateRecordSuccess,
    updateRecordFailure,
    deleteRecord,
    deleteRecordSuccess,
    deleteRecordFailure,
    fetchSingleRecord,
    fetchSingleRecordSuccess,
    fetchSingleRecordFail,
    fetchSpecificData,
    importRecord,
    fetchAddressRecords,
    fetchAddressRecordsSuccess,
    fetchAddressRecordsFail,
    importRecordSuccess,
    importRecordFailure,
    anonymizeRecord,
    anonymizeRecordSuccess,
    anonymizeRecordFailure
} from './member.action';


import {
    fetchSingleRecordSuccess as clubSingleRecordSuccess,
} from '../Clubs/clubs.action';


import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { MemberTableService } from './member-table.service';
import { DatatableService } from 'src/app/core/services/datatable.service';
import { MemberAddressTableService } from './member-address-table.service';
import { HelperService } from 'src/app/core/services/helper.service';

@Injectable()
export class MemberRecordEffects {

    fetchData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchRecords),
            exhaustMap(() => {
                const url = 'member?club=' + this.moduleTableService.clubId;
                return this.crudServerService.fetchTableData(url, this.moduleTableService).pipe(
                    map( (response) => {
                        const data = response.data;

                        this.moduleTableService.page = data.pagination.current_page;
                        this.moduleTableService.lastPage = data.pagination.last_page;
                        this.moduleTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page);

                        this.moduleTableService.clubs = data.clubs;

                        this.alertService.triggerAlert(response.message, "success");
                        return fetchRecordsSuccess({listData: data.records, total: data.pagination.total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchRecordsFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );
    
    fetchAddressData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchAddressRecords),
            exhaustMap((data: any) => {
                const url = 'member-address/'+data.memberId;
                return this.crudServerService.fetchTableData(url, this.moduleAddressTableService).pipe(
                    map( (response) => {
                        const data = response.data;

                        this.moduleAddressTableService.page = data.pagination.current_page;
                        this.moduleAddressTableService.lastPage = data.pagination.last_page;
                        this.moduleAddressTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page);

                        this.moduleAddressTableService.clubs = data.clubs;

                        this.alertService.triggerAlert(response.message, "success");
                        return fetchAddressRecordsSuccess({listData: data.records, total: data.pagination.total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchAddressRecordsFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    fetchSpecificData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSpecificData),
            exhaustMap((data: any) => {
                const url = 'club-members/'+data.clubId;
                return this.crudServerService.fetchTableData(url, this.moduleTableService).pipe(
                    map( (response) => {
                        const data = response.data;
                        
                        this.alertService.triggerAlert(response.message, "success");
                        return fetchRecordsSuccess({listData: data.records, total: data.records?.length});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchRecordsFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    addData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(addRecord),
            exhaustMap((data: any) => {
                const url = 'member';
                return this.crudServerService.addData(url, data.newData).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        if(this.moduleTableService.clubId !== 0){
                            var clubId = this.moduleTableService.clubId;
                            this.routeService.triggerRoute(response, "/clubs/"+clubId+"/members");
                        }else{
                            this.routeService.triggerRoute(response, "/members");
                        }
                        return addRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => addRecordFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })

                )
            })
        )
    );

    importRecord$ = createEffect(() =>
        this.actions$.pipe(
            ofType(importRecord),
            exhaustMap((data: any) => {
                const url = 'import-member';
                return this.crudServerService.addData(url, data.newData).pipe(
                    map( (response) => {
                        const data = response.data;
                        if(data.failedRows){
                            this.alertService.triggerAlert("ALERTS.rows-not-imported | "+data.failedRows, "warning");
                        }

                        this.alertService.triggerAlert(response.message, "success");

                        if(this.moduleTableService.clubId !== 0){
                            var clubId = this.moduleTableService.clubId;
                            this.routeService.triggerRoute(response, "/clubs/"+clubId+"/members");
                        }else{
                            this.routeService.triggerRoute(response, "/members");
                        }
                        return importRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => importRecordFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })

                )
            })
        )
    );
    
    fetchSingle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSingleRecord),
            exhaustMap((data: any) => {
                const url = 'member/'+data.id+"/edit";
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        
                        const data = response.data;
                        const memberData = {countryList: data.countries, clubs: data.clubs, categories: data.categories};
                        this.alertService.triggerAlert(response.message, "success");

                        this.store.dispatch(clubSingleRecordSuccess({singleData: data.club, countryList: data.countries, categories: []}));
                        return fetchSingleRecordSuccess({singleData: data.member, memberData: memberData});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                                this.routeService.triggerRoute(null, "/members");
                            }),
                            map(() => fetchSingleRecordFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    updateData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateRecord),
            exhaustMap((data:any) => {
                const url = 'member-update/'+data.id;
                return this.crudServerService.updateDataPost(url, data.updatedData).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");

                        if(this.moduleTableService.dossierId == 0)
                            this.routeService.triggerRoute(response, "/members/detail/"+data.id);
                        else
                            this.routeService.triggerRoute(response, "/dossiers/detail/"+this.moduleTableService.dossierId);

                        // if(this.moduleTableService.clubId !== 0){
                        //     var clubId = this.moduleTableService.clubId;
                        //     this.routeService.triggerRoute(response, "/clubs/"+clubId+"/members");
                        // }else{
                        //     this.routeService.triggerRoute(response, "/members");
                        // }
                        
                        return updateRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => updateRecordFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })

                )
            })
        )
    );

    deleteData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(deleteRecord),
            exhaustMap((data: any) => {
                const url = 'member/'+data.id;
                return this.crudServerService.deleteData(url).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(fetchRecords());
                        this.routeService.triggerRoute(null, "/members");
                        return deleteRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => deleteRecordFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    anonymizeRecord$ = createEffect(() =>
        this.actions$.pipe(
            ofType(anonymizeRecord),
            exhaustMap((data: any) => {
                const url = 'member-anonymize/'+data.id;
                return this.crudServerService.addData(url, []).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(fetchSingleRecord({id: data.id}));
                        return anonymizeRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => anonymizeRecordFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private store: Store<RootReducerState>,
        private moduleTableService: MemberTableService,
        private moduleAddressTableService: MemberAddressTableService,
        private tableService: DatatableService,
        public helperService: HelperService
    ) { }

}